var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.83325 14.1775L9.51075 14.165L17.5374 6.21496C17.8524 5.89996 18.0258 5.48163 18.0258 5.03663C18.0258 4.59163 17.8524 4.17329 17.5374 3.85829L16.2158 2.53663C15.5858 1.90663 14.4866 1.90996 13.8616 2.53413L5.83325 10.4858V14.1775ZM15.0374 3.71496L16.3616 5.03413L15.0308 6.35246L13.7091 5.03163L15.0374 3.71496ZM7.49992 11.1808L12.5249 6.20329L13.8466 7.52496L8.82242 12.5008L7.49992 12.505V11.1808Z",
    fill: "#b1a9a9",
    fillOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.16667 17.5H15.8333C16.7525 17.5 17.5 16.7525 17.5 15.8333V8.61L15.8333 10.2767V15.8333H6.79833C6.77667 15.8333 6.75417 15.8417 6.7325 15.8417C6.705 15.8417 6.6775 15.8342 6.64917 15.8333H4.16667V4.16667H9.8725L11.5392 2.5H4.16667C3.2475 2.5 2.5 3.2475 2.5 4.16667V15.8333C2.5 16.7525 3.2475 17.5 4.16667 17.5Z",
    fill: "#b1a9a9",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.9d4c1adba5f9f1dec1690f121a5d1cc8.svg";
export { ForwardRef as ReactComponent };